import React, { Component } from 'react'
import firebase from '../modules/Firebase'

class BuildUploader extends Component {
  state = {
    uploadingState: 'IDLE',
    progressPercentage: '0%',
  }

  componentWillUnmount() {
    if (this.successTimeout) {
      clearTimeout(this.successTimeout)
    }
  }

  formToState = (e) => {
    this.setState({
      [e.target.id]: e.target.id === 'package' ? e.target.files : e.target.value
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.uploadPackage(this.state.package[0])
  }

  uploadPackage(appPackage) {
    const { platform, environment, version } = this.state
    const storageRef = firebase.storage().ref()
    const fileName = appPackage.name
    const uploadTask = storageRef.child(`builds/${fileName}`).put(appPackage)
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, 
      ({ state, bytesTransferred, totalBytes }) => {
        this.setState({
          uploadingState: state.toUpperCase(),
          progressPercentage: ((bytesTransferred/totalBytes) * 100).toFixed(2) + '%'
        })
      },
      // Error callback
      (error) => {
        console.log(error)
        this.setState({
          uploadingState: 'ERROR',
        })
      },
      // Success callback
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then(url => {
          this.props.onUploadSuccess({
            platform,
            environment,
            url,
            fileName,
            version
          })
        })
      }
    )
  }

  render() {
    const { uploadingState, progressPercentage }= this.state
    switch(uploadingState) {
      case "RUNNING":
        const progressStyle = {
          width: progressPercentage
        }
        return (
          <div className="progress">
            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={progressStyle} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{progressPercentage}</div>
          </div>
        )
      case "IDLE":
      default:
        return (
          <form onSubmit={this.onSubmit}>
            <div className="form-group">
              <label>Platform</label>
              <select className="form-control" id="platform" onChange={this.formToState}>
                <option></option>
                <option>Tizen</option>
                <option>Samsung</option>
                <option>Roku</option>
              </select>
            </div>
            <div className="form-group">
              <label>Version</label>
              <input type="text" className="form-control" id="version" placeholder="Version" onChange={this.formToState} />
            </div>
            <div className="form-group">
              <label>Environment</label>
              <select className="form-control" id="environment" onChange={this.formToState}>
                <option></option>
                <option>Production</option>
                <option>Staging</option>
                <option>Testing</option>
              </select>
            </div>
            <div className="form-group">
              <label>Package</label>
              <input type="file" id="package" onChange={this.formToState} />
              <p className="help-block">Upload the .wgt, .zip or .pkg file</p>
            </div>
            <button type="submit" className="btn btn-default">Submit</button>
          </form>
        )
    }
  }
}

export default BuildUploader


// WEBPACK FOOTER //
// ./src/components/BuildUploader.js